import type { ReactNode } from 'react';
import DashboardHeader from './Header';

const CURRENT_YEAR = new Date().getFullYear();

interface DashboardLayoutProps {
  children: ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-[#F5F7FA]">
      <DashboardHeader />
      <main className="flex flex-1 flex-col p-6">{children}</main>
      <footer className="py-3 text-center text-xs font-medium text-lightGray">
        © {CURRENT_YEAR} G&T Engine Parts
      </footer>
    </div>
  );
}
